export default __webpack_public_path__ + "static/media/Primer_Mix_of_Primers_1_and_6.c6c7fe79.svg";